import $ from "jquery";
import "magnific-popup";
import Cookies from 'js-cookie';

let init = () => {
    if ($('#country-selector').length) {
        $.magnificPopup.open({
            items: {
                src: '#country-selector',
                type: 'inline'
            },
            modal: true,
            showCloseBtn: false,
            closeOnBgClick: false,
            prependTo: ".country-selector__modal"
        });

        $('.js-country-selector-close').on("click", (e) => {
            $.magnificPopup.close();
        })
    }

    $(document).on('click', '.js-language-item', languageClickEvent);

}

const languageClickEvent = (ev) => {
    let $this = $(ev.currentTarget),
        cultureCode = $this.data("culturecode");
    
    Cookies.set('_cultureCode', cultureCode)
}

export let countrySelector = {
	init: init
}